import { combineAddress, isBranchApplication } from "../../../app/utils";
import * as CONST from "../../../app/constants"
import { 
    isReviewDataNeeded,
    parseApplicantInformation,
    parseApplicationInformationForRenewal,
    parseCriminalHistory,
    parseDocumentsData,
    parseLicenceSuspension,
    // parseRenewedAgentApplicationForRenewal,
    parseSuretyBondData,
    parseSuretyBondRenewalData,
    parseWorkHistory
} from "../bltReviewSelector";
import { isRenewalTypeApplication } from "../../slice/applicationsUtils";
import { getUpdatedDocuemntsWithReviewData, isHavingUpdatedDocuments, parseUpdatedDocumentsInformation } from "./bltReviewMortgageApplication";

function branchApplication (additionalApplications) {
    let branchApp = null;

    if(additionalApplications?.additionalBranchApplications?.length > 0) {
        if(additionalApplications.additionalBranchApplications.length === 1) {
            branchApp = additionalApplications.additionalBranchApplications[0];
        } else if(additionalApplications?.currentBranchApplicationId) {
            const branchAppIndex = additionalApplications.additionalBranchApplications.findIndex(app => app.id === additionalApplications?.currentBranchApplicationId)
            if(branchAppIndex >= 0) {
                branchApp = additionalApplications.additionalBranchApplications[branchAppIndex];
            }
        }
    }

    return branchApp;
}

export function collectionsReviewDataDetails(
    queueItem, 
    primaryAgencyApplication, 
    additionalApplications,
    currentAgentApplication) 
{
    let sectionsByOrder = []; 
    let businessLicenceData = {};
    const commonSections =  ["internalNotesMap","decisionMap"];

    //If cancel agent submitted
    if (
        queueItem?.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT &&
        (queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION ||
            queueItem?.licencingSubType ===
            CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION ||
            queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL ||
            queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL)
    ) {
        businessLicenceData = currentAgentApplication?.businessLicenceData;

        sectionsByOrder = ["applicantInformationMap"];
    }
    else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
        || queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION)
    {
        if(isBranchApplication(queueItem)) 
        {
            const branchApp = branchApplication(additionalApplications);
            businessLicenceData = branchApp?.businessLicenceData
            sectionsByOrder = ["additionalBranchesMap"];
        } else {
            businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

            sectionsByOrder = [
                "applicantInformationMap",
                "criminalHistoryMap",
                "licenceSuspensionDataMap",
                "workHistoryMap",
                "documentsDataMap",
                "suretyBondDataMap"
            ]
        }
    } else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
        || queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL
    ) 
    {
        if(isBranchApplication(queueItem)) {
            const branchApp = branchApplication(additionalApplications);
            businessLicenceData = branchApp?.businessLicenceData
            sectionsByOrder = ["additionalBranchesMap"];
        } else {
            businessLicenceData = primaryAgencyApplication.application?.businessLicenceData
    
            sectionsByOrder = [
                "applicantInformationMap",
                "criminalHistoryMap",
                "licenceSuspensionDataMap",
                "additionalBranchesMap",
                "documentsDataMap",
                // // "renewedAgentsApplicationsMap", Collector not needed in app
                "suretyBondDataMap",
            ]
        }
    } else if(queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION
        || queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION) { 
            
            businessLicenceData = currentAgentApplication?.businessLicenceData

            sectionsByOrder = [
                "applicantInformationMap",
                "criminalHistoryMap",
                "licenceSuspensionDataMap",
            ]
    }

    if (isHavingUpdatedDocuments(queueItem)) {
        if(queueItem?.licenceStatus === CONST.LICENCE_STATUS_ACTIVE) {
            //Ignoring other sections for ACTIVE licence status
            sectionsByOrder = ["updatedDocumentsMap", ...commonSections];
        }
        else {
            sectionsByOrder = [...sectionsByOrder, "updatedDocumentsMap", ...commonSections];
        }
        
    } else {
        sectionsByOrder = [...sectionsByOrder, ...commonSections];
    }

    return { businessLicenceData, sectionsByOrder };
}
/*
[
  {
    "Branch name": "Sackville Branch",
    "Branch address": "123 Sackville Street, Halifax, B3N 3L8",
    "Responsible agent": "Sackville Manager",
    "Phone number": "9028907766",
    "Responsible agent email": "sackvillemanager@gmail.com",
    "mappingKey": "additionalBranchData::0",
    "review": null
  },
  {
    "parameterName": "Branch name",
    "changeFrom": "Dartmouth Branch",
    "changeTo": "Dartmouth Branch",
    "mappingKey": "renewedBranchData::0::0",
    "review": "complete"
  },
  {
    "parameterName": "Branch address",
    "changeFrom": "123 Dartmouth St, Dartmouth, B1B 2B3",
    "changeTo": "123 Dartmouth St, Dartmouth, B1B 2B3",
    "mappingKey": "renewedBranchData::0::1",
    "review": "complete"
  },
  {
    "parameterName": "Responsible agent",
    "changeFrom": "Dartmouth Manager",
    "changeTo": "Dartmouth Manager2",
    "mappingKey": "renewedBranchData::0::2",
    "review": null
  },
  {
    "parameterName": "Phone number",
    "changeFrom": "9021237788",
    "changeTo": "9021238899",
    "mappingKey": "renewedBranchData::0::3",
    "review": null
  },
  {
    "parameterName": "Responsible agent email",
    "changeFrom": "dartmouth.manager@gmail.com",
    "changeTo": "dartmouth.manager2@gmail.com",
    "mappingKey": "renewedBranchData::0::4",
    "review": null
  },
  {
    "Branch name": "Bedford Branch",
    "Branch address": "123 Bedford St, Bedford, B1B2B3",
    "Responsible agent": "Bedford Manager",
    "Phone number": "9021236677",
    "Responsible agent email": "bedford.manager@gmail.com",
    "mappingKey": "notRenewedBranchData::0",
    "review": null
  }
]
 */
/* 
[
  {
    "additionalBranchData": [
      {
        "Branch name": "Sackville Branch",
        "Branch address": "123 Sackville Street, Halifax, B3N 3L8",
        "Responsible agent": "Sackville Manager",
        "Phone number": "9028907766",
        "Responsible agent email": "sackvillemanager@gmail.com",
        "review": null
      }
    ],
    "renewedBranchData": [
      [
        {
          "parameterName": "Branch name",
          "changeFrom": "Dartmouth Branch",
          "changeTo": "Dartmouth Branch",
          "review": "complete"
        },
        {
          "parameterName": "Branch address",
          "changeFrom": "123 Dartmouth St, Dartmouth, B1B 2B3",
          "changeTo": "123 Dartmouth St, Dartmouth, B1B 2B3",
          "review": "complete"
        },
        {
          "parameterName": "Responsible agent",
          "changeFrom": "Dartmouth Manager",
          "changeTo": "Dartmouth Manager2",
          "review": null
        },
        {
          "parameterName": "Phone number",
          "changeFrom": "9021237788",
          "changeTo": "9021238899",
          "review": null
        },
        {
          "parameterName": "Responsible agent email",
          "changeFrom": "dartmouth.manager@gmail.com",
          "changeTo": "dartmouth.manager2@gmail.com",
          "review": null
        }
      ]
    ],
    "notRenewedBranchData": [
      {
        "Branch name": "Bedford Branch",
        "Branch address": "123 Bedford St, Bedford, B1B2B3",
        "Responsible agent": "Bedford Manager",
        "Phone number": "9021236677",
        "Responsible agent email": "bedford.manager@gmail.com",
        "review": null
      }
    ],
    "review": null
  }
]
 */
function parseBranchApplicationData(branchApplication) { 

    const branchesData = []

    const {additionalBranches} = branchApplication.businessLicenceData
    
    if(additionalBranches?.length) { 
        additionalBranches.forEach((branch) => { 
            const {
                branchName,
                address,
                manager
            } = branch
    
            branchesData.push({
                "Branch name" : branchName,
                review : null
            })
            branchesData.push({
                "Branch address" : combineAddress(address),
                review : null
            })
            branchesData.push({
                "Responsible agent" : manager ? manager.firstName : "",
                review : null
            })
            branchesData.push({
                "Phone number" : manager ? manager.phoneNumber : "",
                review : null
            })
            branchesData.push({
                "Responsible agent email" : manager ? manager.emailAddress : "", 
                review : null
            })
        })
    }

    if(!branchesData.length) { 
        branchesData.push({
            review : null
        })
    }

    return branchesData
}

function parseBranchApplicationReviewData(branchApplication,branchApplicationArchive) {
    const branchesReviewData = []

    const {additionalBranches} = branchApplication.businessLicenceData
    const additionalBranchesArchive = branchApplicationArchive?.businessLicenceData?.additionalBranches

    if(additionalBranches?.length) {

        let branchNameArchive,addressArchive, managerArchive;

        if(additionalBranchesArchive?.length) {
            const branchArchive = additionalBranchesArchive[0]
            branchNameArchive = branchArchive.branchName;
            addressArchive = branchArchive.address;
            managerArchive = branchArchive.manager;
        }

        additionalBranches.forEach((branch) => {
            const {
                branchName,
                address,
                manager
            } = branch

            branchesReviewData.push({
                parameterName : "Branch name",
                changeFrom : branchNameArchive,
                changeTo : branchName,
                review : (branchName === branchNameArchive) ? "complete" : null,
            })

            branchesReviewData.push({
                parameterName : "Branch address",
                changeFrom : combineAddress(addressArchive),
                changeTo : combineAddress(address),
                review : (combineAddress(address) === combineAddress(addressArchive)) ? "complete" : null,
            })

            branchesReviewData.push({
                parameterName : "Responsible agent",
                changeFrom : managerArchive?.firstName,
                changeTo : manager?.firstName,
                review : (managerArchive?.firstName === manager?.firstName) ? "complete" : null,
            })

            branchesReviewData.push({
                parameterName : "Phone number",
                changeFrom : managerArchive?.phoneNumber,
                changeTo : manager?.phoneNumber,
                review : (managerArchive?.phoneNumber === manager?.phoneNumber) ? "complete" : null,
            })

            branchesReviewData.push({
                parameterName : "Responsible agent email",
                changeFrom : managerArchive?.emailAddress,
                changeTo : manager?.emailAddress,
                review : (managerArchive?.emailAddress === manager?.emailAddress) ? "complete" : null,
            })
        })
    }

    if (branchesReviewData.every(obj => obj.review === "complete")) {
        branchesReviewData[0].review = null
        branchesReviewData[0].forceSelection = true
    }
    
    return branchesReviewData;
}

export const convertAdditionalBranchRenewalDataFromServer = (dataFromServer) => {
    const additionalBranchData = []
    const renewedBranchData = []
    const notRenewedBranchData = []

    for(const key in dataFromServer) {
        const obj = dataFromServer[key]
        const keyComponents = obj?.mappingKey?.split("::")

        if(keyComponents?.length >= 2) {
            if (keyComponents[0] === "additionalBranchData") {
                additionalBranchData.push(obj)
            } else if(keyComponents[0] === "notRenewedBranchData") {
                notRenewedBranchData.push(obj)
            } else if(keyComponents[0] === "renewedBranchData") {
                const index = parseInt(keyComponents[1])
    
                if(index < renewedBranchData.length) {
                    const innerArray = renewedBranchData[index]
                    renewedBranchData.splice(index, 1, [...innerArray, obj])
                } else {
                    renewedBranchData[index] = [obj]
                }
            }
        }
    }

    return {
        additionalBranchData,
        renewedBranchData,
        notRenewedBranchData
    }
}

export const convertAdditionalBranchRenewalDataFromApplication = (fromApplication) => {
    const serverJson = []

    fromApplication[0]["additionalBranchData"].forEach((obj, index) => {
        serverJson.push({
            ...obj,
            mappingKey : `additionalBranchData::${index}`
        })
    })

    fromApplication[0]["notRenewedBranchData"].forEach((obj, index) => {
        serverJson.push({
            ...obj,
            mappingKey : `notRenewedBranchData::${index}`
        })
    })

    fromApplication[0]["renewedBranchData"].forEach((obj, index) => {
        obj.forEach((innerObj, innerIndex) => {
            serverJson.push({
                ...innerObj,
                mappingKey : `renewedBranchData::${index}::${innerIndex}`
            })
        })
    })

    return serverJson
}

export function parseAdditionalBranchesData(additionalBranchApplications) { 

    let branchesData = []

    if(additionalBranchApplications 
        && Array.isArray(additionalBranchApplications) 
        && additionalBranchApplications.length) 
    {
        additionalBranchApplications.forEach(branchApplication => {
            const {additionalBranches} = branchApplication.businessLicenceData
    
            if(additionalBranches?.length) { 
                additionalBranches.forEach((branch) => { 
                    const {
                        branchName,
                        address,
                        manager
                    } = branch
            
                    branchesData.push({
                        "Branch name" : branchName,
                        "Branch address" : combineAddress(address),
                        "Responsible agent" : manager ? manager.firstName : "",
                        "Phone number" : manager ? manager.phoneNumber : "",
                        "Responsible agent email" : manager ? manager.emailAddress : "", 
                        review : null
                    })
                })
            }
        })
    }

    if(!branchesData.length) { 
        branchesData.push({
            review : null
        })
    }

    return branchesData
}

export const parseAdditionalBranchesDataForRenewal = (additionalBranchApplications, branchArchiveApplications) => {
    // let additionalBranchesMap = {
    //     additionalBranchData : [],
    //     renewedBranchData : [],
    //     notRenewedBranchData : [],
    // }

    const serverJson = []

    const branchesAdded = []
    const branchesRenewed = []
    const branchesNotRenewed = []

    additionalBranchApplications?.forEach((branchApp) => {
        if (
            (branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION ||
                branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION) &&
            (branchApp.applicationStatus === CONST.APPLICATION_STATUS_UNREAD
            // || branchApp.applicationStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY
            // If enabled then, BLTReviewUtils -> handlePostAgencyReviewProcess line 658, identify agency renewl and allow branch approved and active
            )
        ) {
            /* Show only renewal branches other wise handle  BLTReviewUtils -> handlePostAgencyReviewProcess line 658
            identify agency renewl and allow branch approved and active */
            
            // branchesAdded.push(branchApp);

        } else if (
            (branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION ||
                branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION) &&
            branchApp.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED
        ) {
            branchesNotRenewed.push(branchApp);
        } else if (
            (branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL ||
                branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL) &&
            (branchApp.applicationStatus === CONST.APPLICATION_STATUS_UNREAD ||
                branchApp.applicationStatus === CONST.APPLICATION_STATUS_PENDING)
        ) {
            branchesRenewed.push(branchApp);
        }
    });
    
    if(branchesAdded.length) {
        const parsedData = parseAdditionalBranchesData(branchesAdded)
        parsedData.forEach((obj, index) => {
            serverJson.push({
                ...obj,
                mappingKey : `additionalBranchData::${index}`
            })
        })
    }

    if(branchesRenewed.length) {
        const renewedBranches = []
        branchesRenewed.forEach((branchApp, index) => {
            const renewedData = parseAdditionalBranchesData([branchApp])
            let archivedData = undefined

            const archiveAppIndex = branchArchiveApplications.findIndex(app => app.originalApplicationId === branchApp.id)
            if(archiveAppIndex !== -1) {
                const archiveApp = branchArchiveApplications[archiveAppIndex]
                archivedData = parseAdditionalBranchesData([archiveApp])
            } else {
                archivedData = [{
                    "Branch name" : "",
                    "Branch address" : "",
                    "Responsible agent" : "",
                    "Phone number" : "",
                    "Responsible agent email" : "", 
                    review : null
                }]
            }

            const dataChanges = []

            for (const key in renewedData[0]) {
                if(key === "review") 
                    continue

                const changeFrom = archivedData?.[0][key] ?? ""
                const changeTo = renewedData?.[0][key] ?? ""

                dataChanges.push({
                    parameterName: key,
                    changeFrom : changeFrom,
                    changeTo : changeTo,
                    review : (changeFrom === changeTo) ? "complete" : null
                })
            }

            if(dataChanges.every(d => d.review === "complete")) {
                dataChanges[0].review = null
                dataChanges[0].forceSelection = true
            }

            renewedBranches.push(dataChanges)
        })

        renewedBranches.forEach((obj, index) => {
            obj.forEach((innerObj, innerIndex) => {
                serverJson.push({
                    ...innerObj,
                    mappingKey : `renewedBranchData::${index}::${innerIndex}`
                })
            })
        })
    }

    if(branchesNotRenewed.length) {
        const parsedData = parseAdditionalBranchesData(branchesNotRenewed)
        parsedData.forEach((obj, index) => {
            serverJson.push({
                ...obj,
                mappingKey : `notRenewedBranchData::${index}`
            })
        })
    }

    if(!serverJson.length) {
        serverJson.push({
            review : null
        })
    }

    return serverJson
}

export function bltCollectionAgencyBranchReviewData(branchApplication, branchApplicationArchive) {
    const applicationItem = branchApplication.businessLicenceData

    if(isReviewDataNeeded(applicationItem)) {
        const isRenewal = isRenewalTypeApplication(branchApplication)

        if(isRenewal) {
            const additionalBranchesMap = parseBranchApplicationReviewData(branchApplication, branchApplicationArchive);

            return {
                additionalBranchesMap,
                decisionMap: [{
                    adminDecision : "",
                    review : ""
                }],
                internalNotesMap: [{
                    internalNotes : applicationItem.internalNotes,
                    review : (applicationItem.internalNotes?.length > 0) ? "complete" : "" 
                }]
            }
        } else {
            return {
                additionalBranchesMap : parseBranchApplicationData(branchApplication),
                decisionMap: [{
                    adminDecision : "",
                    review : ""
                }],
                internalNotesMap: [{
                    internalNotes : applicationItem.internalNotes,
                    review : (applicationItem.internalNotes?.length > 0) ? "complete" : "" 
                }]
            }
        }
    }
    else if(isHavingUpdatedDocuments(branchApplication)) { 
        applicationItem.reviewDataCollectionDebt = getUpdatedDocuemntsWithReviewData(applicationItem, branchApplication.documents, branchApplication.licenceStatus)

    }

    return applicationItem.reviewDataCollectionDebt
}

export function bltCollectionAgencyReviewData(
    agencyApplication,
    agencyApplicationArchive,
    additionalBranchApplications,
    addAdditionalBranchApplicationArchive, 
    agentApplications
) {
    const applicationItem = agencyApplication.businessLicenceData
    
    if(isReviewDataNeeded(applicationItem)) 
    {
        const isRenewal = isRenewalTypeApplication(agencyApplication)
        const { documents } = agencyApplication

        const criminalHistoryMap = parseCriminalHistory(applicationItem)
        const licenceSuspensionDataMap = parseLicenceSuspension(applicationItem)
        const workHistoryMap = parseWorkHistory(applicationItem)
        const documentsDataMap = parseDocumentsData(documents)

        let applicantInformationMap = {}
        let additionalBranchesMap = {}
        let suretyBondDataMap = {}
        // let renewedAgentsApplicationsMap = {}

        if(isRenewal) {
            const applicationItemArchive = agencyApplicationArchive?.businessLicenceData
            applicantInformationMap = parseApplicationInformationForRenewal(applicationItem,applicationItemArchive)
            const branches = additionalBranchApplications.filter((branchApp) => {
                return (
                    (branchApp.licencingSubType ===
                        CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION ||
                        branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL ||
                        branchApp.licencingSubType ===
                        CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION ||
                        branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL) &&
                    (branchApp.licenceStatus === CONST.LICENCE_STATUS_ACTIVE ||
                        branchApp.licenceStatus === CONST.LICENCE_STATUS_NEW) &&
                    (branchApp.applicationStatus === CONST.APPLICATION_STATUS_UNREAD ||
                        branchApp.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED ||
                        branchApp.applicationStatus === CONST.APPLICATION_STATUS_PENDING)
                );
            });
            additionalBranchesMap = parseAdditionalBranchesDataForRenewal(branches,addAdditionalBranchApplicationArchive)
            suretyBondDataMap = parseSuretyBondRenewalData(documents)
            // renewedAgentsApplicationsMap = parseRenewedAgentApplicationForRenewal(agencyApplication, agentApplications)
        } else {
            applicantInformationMap = parseApplicantInformation(applicationItem)
            additionalBranchesMap = parseAdditionalBranchesData(additionalBranchApplications)
            suretyBondDataMap = parseSuretyBondData(applicationItem)
        }

        const decisionMap = [{
            adminDecision : "",
            review : ""
        }]
        const internalNotesMap = [{
            internalNotes : applicationItem.internalNotes,
            review : (applicationItem.internalNotes?.length > 0) ? "complete" : "" 
        }]

        let reviewData
    
        if(isRenewal) {
            reviewData = {
                applicantInformationMap,
                criminalHistoryMap,
                licenceSuspensionDataMap,
                additionalBranchesMap,
                documentsDataMap,
                suretyBondDataMap,
                internalNotesMap,
                decisionMap
            }
        }
        else {
            reviewData = {
                applicantInformationMap,
                criminalHistoryMap,
                licenceSuspensionDataMap,
                workHistoryMap,
                documentsDataMap,
                suretyBondDataMap,
                internalNotesMap,
                decisionMap
            }
        }

        const updatedDocumentsNotAdded = parseUpdatedDocumentsInformation(applicationItem, documents);
        if(updatedDocumentsNotAdded?.length) {
            reviewData.updatedDocumentsMap = updatedDocumentsNotAdded
        }

        return reviewData;             
    }
    else if(isHavingUpdatedDocuments(agencyApplication)) { 
        applicationItem.reviewDataCollectionDebt = getUpdatedDocuemntsWithReviewData(applicationItem, agencyApplication.documents, agencyApplication.licenceStatus)
    }

    return applicationItem.reviewDataCollectionDebt
}
